import { type DietaryPropertyKind } from '@sg/graphql-schema';

import { type DietaryRestrictionsTypes } from '../setup';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfHasUnsavedPreferences(
  restrictions: DietaryRestrictionsTypes,
  pendingRestrictions: DietaryRestrictionsTypes,
) {
  const restrictionEntries = Object.entries(restrictions);
  const checkIfValuesAreDifferent = checkIfValuesAreDifferentFactory(pendingRestrictions); // prettier-ignore

  return restrictionEntries.some(checkIfValuesAreDifferent);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfValuesAreDifferentFactory(
  pendingRestrictions: DietaryRestrictionsTypes,
) {
  return function (restrictionEntry: RestrictionEntry) {
    const [kind, value] = restrictionEntry;
    const castedKind = kind as DietaryPropertyKind;

    return pendingRestrictions[castedKind] !== value;
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type RestrictionEntry = [string, boolean];
